import { Card, Stack, SimpleGrid, Group, Text, Badge, Loader, Center, Tabs, Table, Button } from "@mantine/core";
import { IconCoins, IconShoppingCart } from "@tabler/icons-react";
import { useBillingAccount, useBillingTransactions, useBillingPurchases, useResource } from "../../../shared/api";
import { PageHeader, MoneyDisplay, EmptyState, KPICard } from "../../../shared/ui";

export function BillingPage() {
  const { data: account, isLoading } = useBillingAccount();
  const { data: txs } = useBillingTransactions();
  const { data: purchases } = useBillingPurchases();
  const { data: packagesData } = useResource<any>("billing-packages");
  const packages: any[] = packagesData?.results || packagesData || [];

  if (isLoading) return <Center h={300}><Loader /></Center>;

  const txList: any[] = Array.isArray(txs) ? txs : (txs as any)?.results || [];
  const purchaseList: any[] = Array.isArray(purchases) ? purchases : (purchases as any)?.results || [];

  return (
    <Stack gap="md">
      <PageHeader title="Kontür / Faturalama" subtitle="Platform kullanım kontürünüz" />

      <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="md">
        <KPICard
          title="Mevcut Bakiye"
          value={`${account?.balance_credits ?? 0} kontür`}
          icon={<IconCoins size={24} />}
          color="teal"
        />
        <KPICard
          title="Toplam Satın Alınan"
          value={`${account?.lifetime_purchased ?? 0}`}
          color="blue"
        />
        <KPICard
          title="Toplam Kullanılan"
          value={`${account?.lifetime_consumed ?? 0}`}
          color="orange"
        />
      </SimpleGrid>

      <Tabs defaultValue="packages">
        <Tabs.List>
          <Tabs.Tab value="packages">Paketler</Tabs.Tab>
          <Tabs.Tab value="transactions">Hareketler ({txList.length})</Tabs.Tab>
          <Tabs.Tab value="purchases">Satın Alma Geçmişi</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="packages" pt="md">
          {packages.length === 0 ? <EmptyState title="Paket yok" /> : (
            <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
              {packages.map((p: any) => (
                <Card key={p.id} padding="lg" radius="md" withBorder>
                  <Stack gap="sm">
                    <Group justify="space-between">
                      <Text fw={700} size="lg">{p.name}</Text>
                      <Badge color="blue" size="lg">{p.credits} kontür</Badge>
                    </Group>
                    <Text c="dimmed" size="sm">{p.description}</Text>
                    <Text fw={700} size="xl" c="blue">
                      <MoneyDisplay minor={p.price_minor} />
                    </Text>
                    <Button leftSection={<IconShoppingCart size={16} />} fullWidth>
                      Satın Al
                    </Button>
                  </Stack>
                </Card>
              ))}
            </SimpleGrid>
          )}
        </Tabs.Panel>

        <Tabs.Panel value="transactions" pt="md">
          <Card padding="sm" radius="md" withBorder>
            <Table.ScrollContainer minWidth={480}>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Tarih</Table.Th>
                  <Table.Th>Tip</Table.Th>
                  <Table.Th>Olay</Table.Th>
                  <Table.Th ta="right">Kontür</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {txList.slice(0, 100).map((t: any) => (
                  <Table.Tr key={t.id}>
                    <Table.Td>{new Date(t.created_at).toLocaleString("tr-TR")}</Table.Td>
                    <Table.Td><Badge variant="light">{t.transaction_type}</Badge></Table.Td>
                    <Table.Td>{t.event_type}</Table.Td>
                    <Table.Td ta="right" c={t.delta_credits >= 0 ? "green" : "red"} fw={600}>
                      {t.delta_credits >= 0 ? "+" : ""}{t.delta_credits}
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
            </Table.ScrollContainer>
          </Card>
        </Tabs.Panel>

        <Tabs.Panel value="purchases" pt="md">
          <Card padding="sm" radius="md" withBorder>
            <Table.ScrollContainer minWidth={480}>
            <Table>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Tarih</Table.Th>
                  <Table.Th>Paket</Table.Th>
                  <Table.Th ta="right">Tutar</Table.Th>
                  <Table.Th>Durum</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {purchaseList.map((p: any) => (
                  <Table.Tr key={p.id}>
                    <Table.Td>{new Date(p.created_at).toLocaleString("tr-TR")}</Table.Td>
                    <Table.Td>{p.package}</Table.Td>
                    <Table.Td ta="right"><MoneyDisplay minor={p.amount_minor || 0} /></Table.Td>
                    <Table.Td><Badge>{p.status}</Badge></Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
            </Table.ScrollContainer>
          </Card>
        </Tabs.Panel>
      </Tabs>
    </Stack>
  );
}
